export const SIGNUP_ACTIONS = {
  SET_NAME: "SET_NAME",
  SET_EMAIL: "SET_EMAIL",
  SET_PHONE: "SET_PHONE",
  SET_PASSWORD: "SET_PASSWORD",
  SET_CONFIRM_PASSWORD: "SET_CONFIRM_PASSWORD",

  EMAIL_OTP_SENT: "EMAIL_OTP_SENT",
  EMAIL_OTP_REFERENCE_SET: "EMAIL_OTP_REFERENCE_SET",
  EMAIL_OTP_SET: "EMAIL_OTP_SET",
  EMAIL_VERIFIED: "EMAIL_VERIFIED",
  EMAIL_VERIFICATION_RESET: "EMAIL_VERIFICATION_RESET",

  PHONE_OTP_SENT: "PHONE_OTP_SENT",
  PHONE_OTP_REFERENCE_SET: "PHONE_OTP_REFERENCE_SET",
  PHONE_OTP_SET: "PHONE_OTP_SET",
  PHONE_VERIFIED: "PHONE_VERIFIED",
  PHONE_VERIFICATION_RESET: "PHONE_VERIFICATION_RESET",
  RESET: "RESET",
  SET_FORM_LOADING: "SET_FORM_LOADING",
};